


let DecisionItemHelperPlugin = {}

DecisionItemHelperPlugin.install = function (Vue, {router, store}) {

    // This function helps us with splitting 2 arrays into 4 array by a given field/property that their elements have
    let splitDecisionItems = (decisionItems3, decisionItems4, field) => {
        let decisionItems3Recommended = [];
        let decisionItems3Possible = [];
        let decisionItems4Recommended = [];
        let decisionItems4Possible = [];

        if (decisionItems3 && decisionItems3.length > 0) {
            decisionItems3Recommended = decisionItems3.filter((item) => {
                if (typeof item[field] !== 'undefined') {
                    return item[field] === true;
                }
                return false;
            })
            decisionItems3Possible = decisionItems3.filter((item) => {
                if (typeof item[field] !== 'undefined') {
                    return item[field] === false;
                }
                return true;
            })
        }
        if (decisionItems4 && decisionItems4.length > 0) {
            decisionItems4Recommended = decisionItems4.filter((item) => {
                if (typeof item[field] !== 'undefined') {
                    return item[field] === true;
                }
                return false;
            })
            decisionItems4Possible = decisionItems4.filter((item) => {
                if (typeof item[field] !== 'undefined') {
                    return item[field] === false;
                }
                return true;
            })
        }
        return {
            decisionItems3Recommended,
            decisionItems3Possible,
            decisionItems4Recommended,
            decisionItems4Possible
        }
    }


    // ==================================
    // Export
    // ==================================

    Vue.mixin({
        computed: {
            DecisionItemHelperPlugin: () => {
                return {
                    splitDecisionItems: splitDecisionItems,
                }
            }
        }
    });

    // Export functions to be used in other places like other plugins, router and so on.
    Vue.DecisionItemHelperPlugin = {
        splitDecisionItems: splitDecisionItems,
    };
    // For some reason, it seems we have to add it to Vue.prototype too if we want to call it from another plugin (even when we are calling it Vue.UtilitiesPlugin from the other plugin).
    Vue.prototype.$DecisionItemHelperPlugin = {
        splitDecisionItems: splitDecisionItems,
    };
}

export default DecisionItemHelperPlugin



// WEBPACK FOOTER //
// ./src/common/plugins/DecisionItemHelperPlugin.js